import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { SP360Logo } from 'assets';
import React from 'react';

import history from '../../history';
function Copyright() {
  return (
    <Typography variant="body2" style={{ color: 'white' }} align="center">
      {'Copyright © '}
      <Link color="inherit" href="/">
        SecurePoint 360
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
const PREFIX = 'ChangePasswordForm';

const classes = {
  paper: `${PREFIX}-paper`,
  avatar: `${PREFIX}-avatar`,
  form: `${PREFIX}-form`,
  submit: `${PREFIX}-submit`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.paper}`]: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  [`& .${classes.avatar}`]: {
    margin: theme.spacing(1),
    backgroundColor: '#FFFFFF',
    height: '60px',
    width: '60px',
  },
  [`& .${classes.form}`]: {
    width: '100%', // Fix IE 11 issue
    marginTop: theme.spacing(1),
  },
  [`& .${classes.submit}`]: {
    margin: theme.spacing(3, 0, 2),
  },
}));
export default function Login(props) {
  return (
    <>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Root className={classes.paper + ' white-form-div'}>
          <Avatar className={classes.avatar + ' avatar-logo'}>
            <img alt="vCISO" className="logo" src={SP360Logo} />
          </Avatar>
          <Typography component="h1" variant="h5" style={{}}>
            Reset Password
          </Typography>
          <form
            className={classes.form}
            onSubmit={(event) => {
              event.preventDefault();
              props.changeUserPassword();
            }}
          >
            {props.parentContext.state.is_passwordchanged === false ? (
              <>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required={true}
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="off"
                  onChange={(element) => {
                    props.setValue('password', element.target.value);
                  }}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required={true}
                  fullWidth
                  name="confirm_password"
                  label="Confirm Password"
                  type="password"
                  id="confirm_password"
                  autoComplete="off"
                  onChange={(element) => {
                    props.setValue('confirm_password', element.target.value);
                  }}
                />
                <Button
                  type="submit"
                  disabled={
                    props.parentContext.state.is_passwordchanged ? true : false
                  }
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Update
                </Button>
              </>
            ) : (
              <p> {props.parentContext.state.success_message} </p>
            )}
            <Grid container>
              <Grid item xs>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={() => {
                    history.push('/login');
                  }}
                >
                  <i
                    className="fa fa-arrow-left"
                    style={{ marginRight: '10px' }}
                    i
                  />
                  Login
                </Button>
              </Grid>
              <Grid item>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={() => {
                    history.push('/privacy-policy');
                  }}
                >
                  Privacy policy
                </Button>
              </Grid>
            </Grid>
          </form>
        </Root>
        <Box mt={8}>
          <Copyright />
        </Box>
      </Container>
    </>
  );
}
